export const useMaintenance = createGlobalState(() => {
  const config = useRuntimeConfig()

  const queryState = useQuery({
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchInterval: MAINTENANCE_REFRESH_INTERVAL,
    refetchIntervalInBackground: true,
    queryKey: ['maintenance'],
    queryFn: ({ signal }) =>
      $fetch<{ maintenance_mode: MaintenanceMode; message: string }>(
        '/maintenance/maintenance_web.json',
        {
          signal,
          baseURL: config.public.assetUrl,
          retry: false,
          timeout: 5000,
        },
      ).catch((err) => {
        console.error(err)
        return null
      }),
  })

  whenever(
    () => queryState.data?.value?.maintenance_mode === MaintenanceMode.START,
    () => {
      try {
        throw showError({
          statusCode: HttpStatusCode.ServiceUnavailable,
        })
      } catch (err) {
        console.error(err)
      }
    },
    { immediate: true },
  )

  whenever(
    () => queryState.data?.value?.maintenance_mode === MaintenanceMode.STOP,
    () => clearError(),
    { immediate: true },
  )

  return queryState
})
